import { render, staticRenderFns } from "./role-select.vue?vue&type=template&id=5c5ce5ce&scoped=true&"
import script from "./role-select.vue?vue&type=script&lang=js&"
export * from "./role-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5ce5ce",
  null
  
)

export default component.exports